/* FootNest: colour switching, free delivery highlights (pop-up on arrival + tag on colour change) */
(function () {
  'use strict';

  /* ---------- Colour circles: swap the photo + keep the right variant selected ---------- */
  document.querySelectorAll('[data-product-hero]').forEach(function (root) {
    var colours = root.querySelector('.ph__colours');
    var mainImg = root.querySelector('[data-main-image]');
    var idInput = root.querySelector('[data-variant-id]');
    var tag = root.querySelector('[data-stage-tag]');
    var thumb = root.querySelector('[data-colour-thumb]');
    var variantMap = {};
    try { var vm = root.querySelector('[data-variant-map]'); if (vm) variantMap = JSON.parse(vm.textContent); } catch (e) { variantMap = {}; }

    function syncVariant() {
      if (!idInput) return;
      var parts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('[data-option]:checked');
        parts[parseInt(fs.dataset.optionIndex, 10)] = checked ? checked.value : '';
      });
      var match = variantMap[parts.join('|')];
      if (match) idInput.value = match.id;
    }

    function showColour(input) {
      if (!input) return;
      var src = input.getAttribute('data-colour-image');
      if (src && mainImg && mainImg.getAttribute('src') !== src) {
        mainImg.style.opacity = 0;
        setTimeout(function () { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.style.opacity = 1; }, 120);
        if (thumb) { thumb.setAttribute('data-src', src); var ti = thumb.querySelector('img'); if (ti) ti.src = src; }
      }
      // Only show the extra photos for this colour (and photos for every colour)
      root.querySelectorAll('[data-thumb-colour]').forEach(function (b) {
        var c = b.getAttribute('data-thumb-colour');
        b.hidden = !!c && c !== input.value;
        b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
      });
      if (thumb) { thumb.classList.add('is-active'); thumb.setAttribute('aria-pressed', 'true'); }
      if (tag) {
        var t = tag.querySelector('[data-stage-tag-text]');
        if (t) t.textContent = (tag.getAttribute('data-tag-template') || '').replace('[colour]', input.value);
        tag.classList.remove('pop'); void tag.offsetWidth; tag.classList.add('pop');
      }
    }

    if (colours) {
      colours.addEventListener('change', function (e) {
        if (e.target.matches('[data-colour-image]')) { showColour(e.target); syncVariant(); }
      });
      // Also react to the tap itself, in case a browser doesn't fire "change"
      colours.addEventListener('click', function (e) {
        var label = e.target.closest('.colour-circle');
        if (!label) return;
        var input = label.querySelector('[data-colour-image]');
        if (input && !input.checked) { input.checked = true; }
        setTimeout(function () { showColour(input); syncVariant(); }, 0);
      });
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) syncVariant(); });

    // Backup add-to-bag with the free delivery pop-up (only if the main script didn't set it up)
    var form = root.querySelector('[data-product-form]');
    var added = root.querySelector('[data-added]');
    if (form && window.fetch && document.body.getAttribute('data-ajax-cart') !== 'false' && !form.hasAttribute('data-ajax-bound')) {
      form.setAttribute('data-ajax-bound', 'backup');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        syncVariant();
        var btn = form.querySelector('[data-add-button]'), err = form.querySelector('[data-form-error]');
        if (err) err.hidden = true;
        if (btn) btn.classList.add('is-loading');
        var base = ((window.theme && window.theme.routes && window.theme.routes.root) || '/').replace(/\/?$/, '/');
        fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to bag');
            return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
            if (!added) { window.location.href = base + 'cart'; return; }
            var img = added.querySelector('[data-added-img]'); if (img && mainImg) img.src = mainImg.src;
            var parts = [];
            root.querySelectorAll('[data-option-index]').forEach(function (fs) { var c = fs.querySelector('[data-option]:checked'); if (c) parts[parseInt(fs.dataset.optionIndex, 10)] = c.value; });
            var v = added.querySelector('[data-added-variant]'); if (v) v.textContent = parts.filter(Boolean).join(' / ');
            var offer = added.querySelector('[data-added-offer]');
            if (offer) {
              var every = parseInt(offer.getAttribute('data-offer-every'), 10) || 0, rem = every ? cart.item_count % every : 0;
              if (!every) offer.hidden = true;
              else if (rem === 0) { offer.className = 'offer-progress offer-progress--done'; offer.textContent = 'Free pair unlocked! The offer is applied at checkout.'; }
              else { var need = every - rem; offer.className = 'offer-progress'; offer.textContent = 'Add ' + need + ' more and get one free.'; }
            }
            added.hidden = false;
            var close = added.querySelector('.added__close'); if (close) close.focus();
          })
          .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
      if (added) {
        added.addEventListener('click', function (e) { if (e.target.closest('[data-close-added]')) added.hidden = true; });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') added.hidden = true; });
      }
    }

    // Quantity buttons (backup)
    var qty = root.querySelector('[data-qty]');
    if (qty && form && form.getAttribute('data-ajax-bound') === 'backup') {
      root.querySelectorAll('[data-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)); });
      });
    }

    // Selected size/option name next to the label (e.g. "Size: 6")
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var fs = e.target.closest('[data-option-index]');
      var label = fs && fs.querySelector('[data-option-value]');
      if (label) label.textContent = e.target.value;
    });

    // Small photos open a full-screen photo viewer with next / previous
    var lb = root.querySelector('[data-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-lb-img]'), lbCount = lb.querySelector('[data-lb-count]'), lbDots = lb.querySelector('[data-lb-dots]');
      var list = [], idx = 0, lastFocus = null;
      function visibleThumbs() { return Array.prototype.filter.call(root.querySelectorAll('[data-thumb]'), function (b) { return !b.hidden; }); }
      function render() {
        var item = list[idx]; if (!item) return;
        lbImg.style.opacity = 0;
        var src = item.getAttribute('data-full');
        var img = new Image();
        img.onload = img.onerror = function () { lbImg.src = src; lbImg.alt = item.getAttribute('data-alt') || ''; lbImg.style.opacity = 1; };
        img.src = src;
        lbCount.textContent = (idx + 1) + ' / ' + list.length;
        lb.classList.toggle('lb--single', list.length < 2);
        lbDots.innerHTML = '';
        list.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'lb__dot' + (i === idx ? ' is-active' : ''); d.setAttribute('aria-label', 'Photo ' + (i + 1));
          d.addEventListener('click', function () { idx = i; render(); });
          lbDots.appendChild(d);
        });
      }
      function open(btn) {
        list = visibleThumbs(); idx = Math.max(0, list.indexOf(btn));
        lastFocus = document.activeElement; lb.hidden = false; document.documentElement.classList.add('lb-open');
        render();
        var c = lb.querySelector('.lb__close'); if (c) c.focus();
      }
      function close() { lb.hidden = true; document.documentElement.classList.remove('lb-open'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
      function step(n) { if (list.length < 2) return; idx = (idx + n + list.length) % list.length; render(); }
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb]');
        if (btn && root.contains(btn) && !btn.closest('[data-lightbox]')) { e.preventDefault(); open(btn); }
      });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) close();
        else if (e.target.closest('[data-lb-prev]')) step(-1);
        else if (e.target.closest('[data-lb-next]')) step(1);
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') step(-1); else if (e.key === 'ArrowRight') step(1);
      });
      var startX = null;
      lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX; startX = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      });
    }
  });

  /* ---------- Welcome offer pop-up (once per visitor) ---------- */
  (function () {
    var promo = document.querySelector('[data-promo]');
    if (!promo) return;
    var KEY = 'footnest-welcome', lastFocus;
    var forced = promo.hasAttribute('data-promo-open'); // just signed up, or the email had an error
    if (forced && location.hash === '#WelcomeForm') {
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      window.scrollTo(0, 0);
    }
    function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function open() {
      lastFocus = document.activeElement; promo.hidden = false;
      document.documentElement.classList.add('lb-open');
      var c = promo.querySelector('.promo__close'); if (c) c.focus({ preventScroll: true });
    }
    function close() {
      promo.hidden = true; remember();
      document.documentElement.classList.remove('lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    promo.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-promo]')) { close(); return; }
      var copy = e.target.closest('[data-copy-code]');
      if (copy) {
        var label = copy.querySelector('[data-copy-label]');
        var done = function () { if (label) label.textContent = 'Copied!'; };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(copy.dataset.copyCode).then(done, function () {});
      }
    });
    var form = promo.closest('form');
    if (form) form.addEventListener('submit', remember);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !promo.hidden) close(); });

    if (forced) { remember(); open(); return; }
    if (document.body.classList.contains('template-cart')) return;
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (seen) return;
    setTimeout(open, (parseInt(promo.dataset.delay, 10) || 0) * 1000);
  })();

})();
